/**
 * <ReportSamCta> — the bottom "conseiller" (Sam) call-to-action block (molecule, L0.1).
 *
 * Mirrors the legacy `LiveReportComponent` bottom block (the `statistics.CTAS.sam` section): the Sam
 * mascot, the CTA copy, and the "Je prends rdv avec mon conseiller" Calendly button. The bookend to
 * `<ReportHero>` at the foot of the `LiveReportDetailsTemplate`. DS-pure — composes `<Mascot>` +
 * `<Text>` + `<Button>` (no legacy `ChampionImageM` / `FilledButtonM`).
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { Mascot } from "../../atoms/Mascot"
import { Button } from "../../atoms/Buttons/Button"

export type ReportSamCtaProps = {
    /** CTA copy (legacy `statistics.CTAS.sam`). */
    message: string
    /** "Je prends rdv avec mon conseiller" (Calendly). */
    onSamPress?: () => void
    testID?: string
}

export function ReportSamCta(props: ReportSamCtaProps) {
    const { message, onSamPress, testID } = props

    return (
        <Stack gap="3" align="center" testID={testID}>
            <Mascot name="sam" variant="happy" size={167} />
            <Text size="text-xl" weight="bold" color="primary" center>
                {message}
            </Text>
            <Button label="Je prends rdv avec mon conseiller" color="success" fullWidth onPress={onSamPress} />
        </Stack>
    )
}
